import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
// eslint-disable-next-line
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// eslint-disable-next-line
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import supplierService from "../../../../services/supplier_appCommonService";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
// eslint-disable-next-line
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getTodaysData } from "../../../../common/Validations";

// eslint-disable-next-line
const ewayBillNumberData = [
  { id: "1", name: "Yes", code: "YES", description: "Yes" },
  { id: "2", name: "No", code: "NO", description: "No" },
];

// eslint-disable-next-line
const accountsStatusNumberData = [
  { id: "1", name: "Hold", code: "HOL", description: "Hold" },
  { id: "2", name: "Cancelled", code: "CAN", description: "Cancelled" },
  { id: "3", name: "Done", code: "DON", description: "Done" },
  { id: "4", name: "Pending", code: "PEN", description: "Pending" },
  {
    id: "5",
    name: "Reconciliation",
    code: "REC",
    description: "Reconciliation",
  },
];

const ServiceVisitInvoiceModal = React.forwardRef(
  ({ show, onHide, serviceData, onSuccess }, ref) => {
    // ── Card visibility (matches ErfInvoiceModal pattern) ──────────────────────
    const [isCardVisible1, setCardVisible1] = useState(true);
    const [isCardVisible2, setCardVisible2] = useState(true);
    const [isCardVisible3, setCardVisible3] = useState(true);
    // eslint-disable-next-line
    const [isCardVisible4, setCardVisible4] = useState(true);
    // eslint-disable-next-line
    const [isCardVisible5, setCardVisible5] = useState(true);

    const toggleCardVisibility1 = () => setCardVisible1((p) => !p);
    const toggleCardVisibility2 = () => setCardVisible2((p) => !p);
    const toggleCardVisibility3 = () => setCardVisible3((p) => !p);
    // eslint-disable-next-line
    const toggleCardVisibility4 = () => setCardVisible4((p) => !p);
    // eslint-disable-next-line
    const toggleCardVisibility5 = () => setCardVisible5((p) => !p);

    // ── State ──────────────────────────────────────────────────────────────────
    const [invoiceData, setInvoiceData] = useState({});
    const [serviceRequiredItems, setServiceRequiredItems] = useState([]);
    const [companyDetails, setCompanyDetails] = useState(null);
    // eslint-disable-next-line
    const [getDropdownData, setDropdownData] = useState("");
    const [disable, setDisabled] = useState(false);
    // eslint-disable-next-line
    const [files, setFiles] = useState(null);
    const [getShowFileViewModal, setShowFileViewModal] = useState(false);
    const [getFileViewData, setFileViewData] = useState(null);
    const [getShowFailureModal, setShowFailureModal] = useState(false);
    // eslint-disable-next-line
    const [getErrorFields, setErrorFields] = useState([]);
    const failureModalData = { title: "Warning", ErrorMsg: "" };
    const [getFailureModal] = useState(failureModalData);

    // IGST if out-of-state; CGST+SGST if Haryana
    const isIGST =
      invoiceData?.billingState !== "Haryana" &&
      invoiceData?.billingState !== "IN - Haryana" &&
      invoiceData?.stateCode !== "06";

    // ── Column definition for serviceRequiredItems ─────────────────────────────
    const serviceItemsCol = [
      {
        name: "Sl No.",
        cell: (row) => <p className="m-0 p-0">{row?.slNo}</p>,
        width: "70px",
      },
      {
        name: "Product",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription}</p>
            <p className="m-0 p-0">{row?.materialCode}</p>
          </div>
        ),
        width: "260px",
      },
      {
        name: "Item Type",
        cell: (row) => <span>{row?.itemType || "--"}</span>,
        width: "110px",
      },
      {
        name: "Barcode",
        selector: (row) => row?.currentBarcode || row?.returnedBarcode || "--",
        width: "200px",
      },
      {
        name: "Qty",
        cell: (row) => <span>{row?.quantity || 1}</span>,
        width: "80px",
      },
    ];

    // ── Load data when modal opens ─────────────────────────────────────────────
    useEffect(() => {
      if (!show || !serviceData) return;

      const data = serviceData;

      // Map serviceRequiredItems to add slNo
      const items = (data?.serviceRequiredItems || []).map((item, idx) => ({
        ...item,
        slNo: idx + 1,
      }));

      setInvoiceData({
        ...data,
        // Pre-fill net amount from amountToCollect if already set
        serviceNetAmount: data?.serviceNetAmount || data?.amountToCollect || "",
      });
      setServiceRequiredItems(items);

      if (data?.signature) loadUploadedFiles(data.signature);
      if (data?.companyNr) getCompanyDetails(data.companyNr);

      // eslint-disable-next-line
    }, [show, serviceData]);

    // ── Sync dropdown selections into invoiceData ──────────────────────────────
    useEffect(() => {
      setInvoiceData((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }, [getDropdownData]);

    // ── Escape key closes modal ────────────────────────────────────────────────
    useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape" || e.keyCode === 27) onHide();
      };
      document.addEventListener("keydown", handler);
      return () => document.removeEventListener("keydown", handler);
    }, [onHide]);

    // ── Handlers ───────────────────────────────────────────────────────────────
    // eslint-disable-next-line
    const onInputChange = ({ target: { name, value } }) => {
      setInvoiceData((prev) => ({ ...prev, [name]: value }));
    };

    const handleCancel = () => onHide();

    const getCompanyDetails = async (id) => {
      if (!id) return;
      try {
        const res = await ItemServiceV2.generateCustomerQuery({
          queryName: "Get_CompanyMaster_Details",
          documentNumber: id,
        });
        if (res?.status === 200 && res?.data) {
          setCompanyDetails(res.data?.[0]);
        }
      } catch (error) {
        console.error("Failed to load company details", error);
      }
    };

    // const handleSave = async () => {
    //   if (
    //     !invoiceData?.serviceGrossTotal ||
    //     Number(invoiceData.serviceGrossTotal) <= 0
    //   ) {
    //     toast.error(
    //       "No service amount found. Please recreate the service form.",
    //     );
    //     return;
    //   }

    //   try {
    //     setDisabled(true);

    //     const updatePayload = {
    //       erfServiceNumber: invoiceData?.erfServiceNumber,
    //       invoiceCreated: true,
    //       invoiceDate: getTodaysData(),
    //       amountToCollect: invoiceData?.serviceGrossTotal,
    //       serviceNetTotal: invoiceData?.serviceNetTotal,
    //       serviceTaxTotal: invoiceData?.serviceTaxTotal,
    //       serviceGrossTotal: invoiceData?.serviceGrossTotal,
    //       taxPercentage: invoiceData?.taxPercentage,
    //       accountsStatus: invoiceData?.accountsStatus,
    //       accountsStatusCode: invoiceData?.accountsStatusCode,
    //       accountsStatusDesc: invoiceData?.accountsStatusDesc,
    //       creditNoteNumber: invoiceData?.creditNoteNumber,
    //       accountsRemarks: invoiceData?.accountsRemarks,
    //       ewayBill: invoiceData?.ewayBill,
    //       ewayBillCode: invoiceData?.ewayBillCode,
    //       ewayBillDesc: invoiceData?.ewayBillDesc,
    //       creditNoteAttachment: invoiceData?.creditNoteAttachment,
    //       accountsRefundStatus: invoiceData?.accountsRefundStatus,
    //       accountsRefundStatusCode: invoiceData?.accountsRefundStatusCode,
    //       accountsRefundStatusDesc: invoiceData?.accountsRefundStatusDesc,
    //       accountsRefundRemarks: invoiceData?.accountsRefundRemarks,
    //       signature: invoiceData?.signature,
    //     };

    //     const response = await ItemService.updateErfService(updatePayload);

    //     if (response?.status === 200) {
    //       toast.success(response?.message || "Invoice saved successfully", {
    //         duration: 2000,
    //         position: "top-right",
    //       });
    //       onSuccess?.();
    //       onHide();
    //     } else {
    //       toast.error(response?.message || "Please try again!", {
    //         duration: 4000,
    //         position: "top-right",
    //       });
    //     }
    //   } catch {
    //     toast.error("Something went wrong!", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //   } finally {
    //     setDisabled(false);
    //   }
    // };

    const handleSave = async () => {
      if (
        !invoiceData?.serviceGrossTotal ||
        Number(invoiceData.serviceGrossTotal) <= 0
      ) {
        toast.error(
          "No service amount found. Please recreate the service form.",
        );
        return;
      }

      try {
        setDisabled(true);

        // ── Step 1: Build invoice document payload ───────────────────────────
        // Strip mongo-specific keys before sending to addInvoice
        const { _id, documentNumber, ...cleanServiceData } = invoiceData;

        // Service items get local_id for invoice line tracking
        const serviceItems = (invoiceData?.serviceRequiredItems || []).map(
          (item, index) => ({
            ...item,
            local_id: index + 1,
            // ensure money fields exist per line if your backend wants them; can be 0
            netValue: 0,
            taxAmount: 0,
            grossValue: 0,
          }),
        );

        const invoicePayload = {
          data: {
            ...cleanServiceData,
            // Link back to the source service record
            sourceServiceNr: invoiceData?.erfServiceNumber,
            // Standard invoice headers (same pattern as ErfInvoiceModal)
            generatedDate: getTodaysData(),
            postingDate: getTodaysData(),
            transaction: "Sales",
            invoiceCategory: "SERVICE_VISIT",
            transactionType: "INV",
            typeOfOperation: "Single",
            // Service totals stored on header
            serviceNetTotal: invoiceData?.serviceNetTotal,
            serviceTaxTotal: invoiceData?.serviceTaxTotal,
            serviceGrossTotal: invoiceData?.serviceGrossTotal,
            taxPercentage: invoiceData?.taxPercentage,
            // Invoice-time inputs
            accountsStatus: invoiceData?.accountsStatus,
            accountsStatusCode: invoiceData?.accountsStatusCode,
            accountsStatusDesc: invoiceData?.accountsStatusDesc,
            creditNoteNumber: invoiceData?.creditNoteNumber,
            accountsRemarks: invoiceData?.accountsRemarks,
            ewayBill: invoiceData?.ewayBill,
            ewayBillCode: invoiceData?.ewayBillCode,
            ewayBillDesc: invoiceData?.ewayBillDesc,
            creditNoteAttachment: invoiceData?.creditNoteAttachment,
            accountsRefundStatus: invoiceData?.accountsRefundStatus,
            accountsRefundStatusCode: invoiceData?.accountsRefundStatusCode,
            accountsRefundStatusDesc: invoiceData?.accountsRefundStatusDesc,
            accountsRefundRemarks: invoiceData?.accountsRefundRemarks,
            signature: invoiceData?.signature,
            // Items
            items: serviceItems,
            serviceItems,
          },
        };

        // ── Step 2: Update the service record (flag invoiceCreated) ───────────
        const servicePayload = {
          erfServiceNumber: invoiceData?.erfServiceNumber,
          invoiceCreated: true,
          invoiceDate: getTodaysData(),
          accountsStatus: invoiceData?.accountsStatus,
          accountsStatusCode: invoiceData?.accountsStatusCode,
          accountsStatusDesc: invoiceData?.accountsStatusDesc,
          creditNoteNumber: invoiceData?.creditNoteNumber,
          accountsRemarks: invoiceData?.accountsRemarks,
          ewayBill: invoiceData?.ewayBill,
          ewayBillCode: invoiceData?.ewayBillCode,
          ewayBillDesc: invoiceData?.ewayBillDesc,
          creditNoteAttachment: invoiceData?.creditNoteAttachment,
          accountsRefundStatus: invoiceData?.accountsRefundStatus,
          accountsRefundStatusCode: invoiceData?.accountsRefundStatusCode,
          accountsRefundStatusDesc: invoiceData?.accountsRefundStatusDesc,
          accountsRefundRemarks: invoiceData?.accountsRefundRemarks,
          signature: invoiceData?.signature,
        };

        // ── Execute in sequence ──────────────────────────────────────────────
        const addRes = await ItemServiceV2.addInvoice(invoicePayload);

        if (addRes?.status === 200) {
          // Only flag the service record AFTER the invoice document exists
          await ItemService.updateErfService(servicePayload);

          toast.success(addRes?.message || "Invoice saved successfully", {
            duration: 2000,
            position: "top-right",
          });
          onSuccess?.();
          onHide();
        } else {
          toast.error(addRes?.message || "Please try again!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (err) {
        console.error("Service Visit Invoice save error:", err);
        toast.error("Something went wrong!", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        setDisabled(false);
      }
    };
    // ── File upload helpers ────────────────────────────────────────────────────
    // eslint-disable-next-line
    const onSuccessUploadsignatureCard = (data) => {
      const attachmentId = data?.attachmentId || "";
      if (!attachmentId) {
        toast.error("Upload failed: Missing attachment ID.");
        return;
      }
      setInvoiceData((prev) => ({ ...prev, signature: attachmentId }));
      loadUploadedFiles(attachmentId);
      toast.success("Uploaded successfully");
    };

    // eslint-disable-next-line
    const onSuccessUploadCreditNoteCard = (data) => {
      const attachmentId = data?.attachmentId || "";
      if (!attachmentId) {
        toast.error("Upload failed: Missing attachment ID.");
        return;
      }
      setInvoiceData((prev) => ({
        ...prev,
        creditNoteAttachment: attachmentId,
      }));
      toast.success("Uploaded successfully");
    };

    // eslint-disable-next-line
    const handleDeletePatientDocument = async (docType) => {
      const attachmentId =
        docType === "signature"
          ? invoiceData.signature
          : invoiceData.creditNoteAttachment;
      if (!attachmentId) {
        toast.error("No document to delete");
        return;
      }
      try {
        const response = await ItemService.deleteFile({ attachmentId });
        if (response?.message) {
          setInvoiceData((prev) => ({ ...prev, [docType]: "" }));
          if (docType === "signature") setFiles(null);
          toast.success(
            docType === "signature"
              ? "Signature deleted"
              : "Credit Note deleted",
          );
        } else {
          toast.error("Failed to delete document");
        }
      } catch {
        toast.error("Error deleting document");
      }
    };

    const handleAttachmentDeleted = ({ hasFiles, remainingCount }) => {
      if (hasFiles && remainingCount === 0) {
        setInvoiceData((prev) => ({
          ...prev,
          signature: "",
          creditNoteAttachment: "",
        }));
      }
    };

    const loadUploadedFiles = async (attachmentId) => {
      if (!attachmentId) return;
      await supplierService.getUploadedFiles({ attachmentId }).then((item) => {
        setFiles(item?.data?.[item.data.length - 1] || null);
      });
    };

    // eslint-disable-next-line
    const handleViewFile = (fileAttachmentId) => {
      setFileViewData(fileAttachmentId);
      setShowFileViewModal(true);
    };

    // ── Render ─────────────────────────────────────────────────────────────────
    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="service-visit-invoice-modal"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="service-visit-invoice-modal">
            Service Visit Invoice — {invoiceData?.erfServiceNumber}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="">
          {/* ── 01: Invoice Address ─────────────────────────────────────────── */}
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility1}
                    />
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">ID</span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Invoice Address</span>
                    <span className="subHeaderTitle">Invoice details</span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible1 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        {/* Company info */}
                        <Col xs={12} md={12} lg={12} className="px-2">
                          <p className="text-lg mb-0 fw-bold">
                            {companyDetails?.firstName}
                          </p>
                          <p className="text-lg mb-0">
                            {companyDetails?.address} {companyDetails?.address2}{" "}
                            {companyDetails?.cityPostalCode}
                          </p>
                          <p className="m-0 p-0">
                            Email:{" "}
                            {companyDetails?.contactDetails?.[0]?.contactEmail}
                          </p>
                          <p className="m-0 p-0">
                            Contact No: {companyDetails?.mobileNr}
                          </p>
                          <p>GST: {companyDetails?.gstNumebr}</p>
                        </Col>

                        {/* Billing & Service Info */}
                        <Col xs={12} md={12} lg={12}>
                          <Row>
                            <Col xs={12} md={4} lg={4} className="ps-2">
                              <p className="fw-bold mb-0">Bill To:</p>
                              <p className="text-lg mb-0">
                                {invoiceData?.patientName}
                              </p>
                              <p className="text-lg mb-0">
                                {invoiceData?.billingAddress}
                              </p>
                              <p className="text-lg mb-0">
                                {invoiceData?.billingState}{" "}
                                {invoiceData?.billingPinCode}
                              </p>
                            </Col>

                            <Col xs={6} md={6} lg={6}>
                              <Row>
                                <Col xs={12} md={12} lg={12} className="p-2">
                                  <p className="fw-bold mb-0">
                                    Service Reference:
                                  </p>
                                  <p className="text-lg mb-0">
                                    <b>Service No: </b>
                                    {invoiceData?.erfServiceNumber}
                                  </p>
                                  <p className="text-lg mb-0">
                                    <b>ERF: </b>
                                    {invoiceData?.equipmentRentNr}
                                  </p>
                                  <p className="text-lg mb-0">
                                    <b>Service Date: </b>
                                    {invoiceData?.serviceDate}
                                  </p>
                                  <p className="text-lg mb-0">
                                    <b>Service Executive: </b>
                                    {invoiceData?.assignedServiceExecutives?.[0]
                                      ?.serviceProviderName || "--"}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          {/* ── 02: Service Required Items ──────────────────────────────────── */}
          {serviceRequiredItems.length > 0 && (
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      />
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SI</span>
                    </Col>
                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Service Items</span>
                      <span className="subHeaderTitle">
                        Materials used during service
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <DataTable
                              title=""
                              columns={serviceItemsCol}
                              data={serviceRequiredItems}
                              pagination
                              paginationServer
                            />
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ── 03: Service Charges & Tax ───────────────────────────────────── */}
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility3}
                    />
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">SC</span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Service Charges</span>
                    <span className="subHeaderTitle">
                      Amount &amp; Tax ({invoiceData?.taxPercentage || 18}%)
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible3 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Net Amount (excl. GST)"
                              name="serviceNetTotal"
                              value={invoiceData?.serviceNetTotal || ""}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={2}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="GST %"
                              name="taxPercentage"
                              value={invoiceData?.taxPercentage || ""}
                              disabled={true}
                            />
                          </Col>

                          {isIGST ? (
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label={`IGST (${invoiceData?.taxPercentage || 18}%)`}
                                value={invoiceData?.serviceTaxTotal || ""}
                                disabled={true}
                              />
                            </Col>
                          ) : (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={2}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label={`CGST (${Number(invoiceData?.taxPercentage || 18) / 2}%)`}
                                  value={
                                    Number(invoiceData?.serviceTaxTotal || 0) /
                                    2
                                  }
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={2}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label={`SGST (${Number(invoiceData?.taxPercentage || 18) / 2}%)`}
                                  value={
                                    Number(invoiceData?.serviceTaxTotal || 0) /
                                    2
                                  }
                                  disabled={true}
                                />
                              </Col>
                            </>
                          )}

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Gross Total (incl. GST)"
                              name="serviceGrossTotal"
                              value={invoiceData?.serviceGrossTotal || ""}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          {/* ── 04: Information to be filled ────────────────────────────────── */}
          {/* <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility4}
                    />
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">IF</span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Information to be filled</span>
                    <span className="subHeaderTitle">
                      Information to be filled
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible4 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Accounts Status"
                              extraLabel=""
                              name="accountsStatus"
                              code="accountsStatusCode"
                              description="accountsStatusDesc"
                              data={accountsStatusNumberData}
                              id="accountsStatus"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.accountsStatus}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Note Number"
                              name="creditNoteNumber"
                              id="creditNoteNumber"
                              value={invoiceData?.creditNoteNumber || ""}
                              onChange={onInputChange}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Accounts Remarks"
                              name="accountsRemarks"
                              id="accountsRemarks"
                              value={invoiceData?.accountsRemarks || ""}
                              onChange={onInputChange}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="e-Way Bill Number"
                              extraLabel=""
                              name="ewayBill"
                              code="ewayBillCode"
                              description="ewayBillDesc"
                              data={ewayBillNumberData}
                              id="ewayBill"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.ewayBill}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>

                          {!invoiceData?.invoiceCreated && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponentForHB
                                    id="creditNoteAttachment"
                                    name="creditNoteAttachment"
                                    label="Credit Note"
                                    allowedTypes={["image/png", "image/jpeg"]}
                                    multiple={true}
                                    onSuccessUpload={onSuccessUploadCreditNoteCard}
                                    value={
                                      invoiceData?.creditNoteAttachment || ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {invoiceData?.creditNoteAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="attachmentIcon me-2"
                                      alt="view"
                                      onClick={() =>
                                        handleViewFile(
                                          invoiceData?.creditNoteAttachment,
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      title="View Credit Note"
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          )}

                          {invoiceData?.invoiceCreated && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {invoiceData?.creditNoteAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="attachmentIcon me-2"
                                      alt="view"
                                      onClick={() =>
                                        handleViewFile(
                                          invoiceData?.creditNoteAttachment,
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      title="View Credit Note"
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div> */}

          {/* ── 05: Refund Information ──────────────────────────────────────── */}
          {/* <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility5}
                    />
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">RI</span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">
                      Refund Information to be filled
                    </span>
                    <span className="subHeaderTitle">
                      Refund Information to be filled
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible5 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Refund Status"
                              extraLabel=""
                              name="accountsRefundStatus"
                              code="accountsRefundStatusCode"
                              description="accountsRefundStatusDesc"
                              data={accountsStatusNumberData}
                              id="accountsRefundStatus"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.accountsRefundStatus}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Remarks"
                              name="accountsRefundRemarks"
                              id="accountsRefundRemarks"
                              value={invoiceData?.accountsRefundRemarks || ""}
                              onChange={onInputChange}
                              disabled={invoiceData?.invoiceCreated}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div> */}

          {/* ── Save / Cancel ──────────────────────────────────────────────── */}
          {!invoiceData?.invoiceCreated && (
            <Row className="my-4">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end mt-2"
              >
                <button className="btnTable btn-danger" onClick={handleCancel}>
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end mt-2">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disable}
                >
                  Save
                </button>
              </Col>
            </Row>
          )}

          <FileViewerModalForHB
            show={getShowFileViewModal}
            onHide={() => setShowFileViewModal(false)}
            fileid={getFileViewData}
            onDeleteSuccess={handleAttachmentDeleted}
            showDelete={!invoiceData?.invoiceCreated}
          />
          <FailureModal
            show={getShowFailureModal}
            onHide={() => setShowFailureModal(false)}
            failuremodaldata={getFailureModal}
            requiredfields={getErrorFields}
          />
        </Modal.Body>
      </Modal>
    );
  },
);

ServiceVisitInvoiceModal.displayName = "ServiceVisitInvoiceModal";
export default ServiceVisitInvoiceModal;
